import { axiosClient } from '@/utils/axios-client'
import type { EuralCode } from '@logistiek-zonder-papier/lzp-library'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useEuralStore = defineStore('euralStore', () => {
  const euralCodes = ref<EuralCode[]>([])

  async function fetchEuralCodes() {
    if (euralCodes.value.length > 0) return euralCodes.value

    const response = await axiosClient.request<{ '@graph': EuralCode[] }>({
      url: 'https://data.ovam.be/doc/euralcode',
      method: 'GET',
      headers: { Authorization: null },
    })

    for (const euralCode of response.data['@graph']) {
      if (euralCode.identifier == null) continue

      euralCodes.value.push({
        identifier: euralCode.identifier,
        hazerdous: euralCode.hazerdous,
        prefLabel: { ...euralCode.prefLabel },
      })
    }

    return euralCodes.value
  }

  return {
    euralCodes,
    fetchEuralCodes,
  }
})
